<template>
    <paper class="receiptCenter">
        <div style="color:red; font-size:13px; height:24px">因审计合规需要，平台需对涉及用户隐私的关键字段（包括但不限于姓名、身份证号、手机号、详细地址等）进行统一脱敏处理。</div>
        <m-pane
            ref="tablePage"
            :virtual="true"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :pickerConfig="timeRangeShortcuts"
            :searchTotalTitle="config.searchTotalTitle"
            :loading="loading"
            searchId="performance-receiptCenterQuery"
            pageID="performance-receiptCenter"
            :currentPage="query.pageNo"
            :extraFixedHeight="24"
            :btnColSpan="4"
            @row-db-click="
                (row) => openSignInDialog(row, '回单详情', 'RECEIPT_DETAIL')
            "
            @receipt-btn="
                (row) => openSignInDialog(row, '回单签收', 'SIGN_COMFIRM', 1)
            "
            @reject-btn="
                (row) => openSignInDialog(row, '回单拒收', 'REJECT_COMFIRM')
            "
            @rePush-btn="
                (row) => openSignInDialog(row, '签收重推', 'SIGN_PUSH')
            "
            @chargeEdit-btn="
                (row) => openSignInDialog(row, '回单签收', 'RECEIPT_DETAIL', 1)
            "
            @preReceipt-btn="openPreReceiptDialog"
            @preReceiptLog-btn="openPreReceiptLog"
            @overdueDetailQuery-btn="handleOverdueDetailQueryBtn"
            @overdueRegister-btn="handleOverdueRegister"
            @change-btn="signChangeRefuse"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @btnClick="handleBtnClick"
            @recheck-btn="recheckBtn"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @photos-btn="photosBtn"
            @upload-btn="uploadBtn"
            @uploadFile-btn="uploadBtn"
            @onReveal-btn="onReveal"
        >

            <span slot="search-list-advance-last">
                <el-dropdown style="margin-left: 8px">
                    <el-button type="primary">
                        标签<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="handleAddLabel">新建标签</el-dropdown-item>
                        <el-dropdown-item @click.native="handleLabelManage">标签管理</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </span>
            <div slot="table-module-btn">
                <el-tooltip effect="dark" :content="this.config.table.leftOperation ? '折叠操作栏' :'展开操作栏'" placement="bottom">
                    <el-button size="mini" :icon="this.config.table.leftOperation ? 'el-icon-d-arrow-right' :'el-icon-d-arrow-left'" @click="foldActionBar" style="margin-right: 8px;"></el-button>
                </el-tooltip>
                <template v-if="showEye">
                    <el-tooltip effect="dark" content="整页解密" placement="bottom">
                        <el-button icon="el-icon-view" size="mini" :disabled="pageTotal === 0" @click="onRevealAll"></el-button>
                    </el-tooltip>
                </template>
                <reportExport #default="{ submit }" reportCode="OTP_RECEIPT_CENTER_REPORT">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button icon="icon-daochu" size="mini" :disabled="pageTotal === 0" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
                <reportExport #default="{ submit }" reportCode="RECEIPT_CENTER_DETAIL_REPORT">
                    <el-tooltip effect="dark" content="导出签收商品明细" placement="bottom">
                        <span style="margin-left: 8px;">
                            <el-button icon="icon-daochu" size="mini" :disabled="pageTotal === 0" @click="exportDetailFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button
                    type="primary"
                    v-if="false"
                    @click="handleBatchReceipt"
                    v-has="'150203005'"
                >批量签收</el-button>
                <el-button type="primary" @click="handleBatchUploadReceipt">批量上传回单</el-button>
                <el-button
                    type="primary"
                    v-if="false"
                    :loading="btnLoading"
                    @click="handleExceptionApprove"
                    v-has="'150203007'"
                >异常审批</el-button>
                <el-button
                    type="primary"
                    v-if="false"
                    @click="handleBatchOverdueRegister"
                    v-has="'150203010'"
                >批量逾期</el-button>
                <el-button
                    type="primary"
                    @click="handleBatchViewFile"
                >批量查看附件</el-button>
                <el-button
                    type="primary"
                    @click="handleBatchDeleteFile"
                >批量删除附件</el-button>
            </div>
        </m-pane>

        <!-- 签收|拒收|重推|回单详情弹窗 -->
        <sign-in-dialog
            v-if="signInShow"
            ref="signInDialog"
            :signInShow.sync="signInShow"
            :rowData="rowData"
            :dialogConfig="dialogConfig"
            :dictData="dictData"
            @uploadAttachmentSuccess="getList"
            @deleteAttachmentSuccess="getList"
            @success="handleSuccess"
        ></sign-in-dialog>

        <!-- 回单印鉴 弹框 -->
        <SealDialog
            v-if="sealShow"
            :sealShow.sync="sealShow"
            :dictData="dictData"
            :rowData="rowData"
        ></SealDialog>

        <!-- 签收改拒收弹窗 -->
        <sign-change-refuse
            v-if="signChangeRefuseShow"
            ref="SignChangeRefuse"
            :signChangeRefuseShow.sync="signChangeRefuseShow"
            :rowData="rowData"
            :signChangeRefuseConfig="signChangeRefuseConfig"
            :dictData="dictData"
            @uploadAttachmentSuccess="getList"
            @deleteAttachmentSuccess="getList"
            @success="handleSuccess"
        ></sign-change-refuse>

        <pre-receipt-dialog
            v-if="preReceiptDialogShow"
            ref="preReceiptDialog"
            :preReceiptDialogShow.sync="preReceiptDialogShow"
            :rowData="rowData"
            @success="handleSuccess"
        ></pre-receipt-dialog>

        <pre-receipt-log
            ref="preReceiptLogDialog"
            v-if="logDialogVisible"
            :rowData="rowData"
            :logDialogVisible.sync="logDialogVisible"
        ></pre-receipt-log>

        <!-- 反查 弹框 -->
        <ReviewDialog
            isSignCenter
            v-if="reviewShow"
            :reviewShow.sync="reviewShow"
            :rowData="rowData"
            @finish="getList"
        ></ReviewDialog>

        <!-- 批量上传回单 -->
        <batch-receipt-upload-dialog
            v-if="batchReceiptUploadVisible"
            :batchReceiptUploadVisible.sync="batchReceiptUploadVisible"
            :selected="selected"
            @success="handleSuccess"
        ></batch-receipt-upload-dialog>

        <!-- 逾期登记 -->
        <overdue-register-dialog
            ref="overdueRegisterDialog"
            v-if="overdueRegisterVisible"
            :overdueRegisterVisible.sync="overdueRegisterVisible"
            :selected="selected"
            @success="handleSuccess"
        ></overdue-register-dialog>

        <!-- 逾期明细查询弹窗 -->
        <overdue-detail-search-dialog
            ref="overdueDetailSearchDialog"
            v-if="overdueDetailSearchVisible"
            :overdueDetailSearchVisible.sync="overdueDetailSearchVisible"
            :rowData="rowData"
        ></overdue-detail-search-dialog>

        <!-- 佐证附件上传 -->
        <evidence-upload-dialog
            ref="leftUploadRightContent"
            :visible.sync="leftUploadRightContentVisible"
            :attachmentList="attachmentList"
            :config="dialogConfig"
            :rowData="rowData"
            v-if="leftUploadRightContentVisible"
            @upload-success="handleSuccess"
        ></evidence-upload-dialog>

        <!-- 查看附件 -->
        <performance-preview-file
            ref="performancePreviewFile"
            :attachmentList="tableAttachmentList"
        ></performance-preview-file>

        <!-- 附件上传 -->
        <performance-common-upload
            ref="performanceCommonUpload"
            :type="'icon'"
            :custom-class="'list-upload'"
            :showFileList="false"
            :accept="'.jpg,.jpeg,.png,.bmp'"
            :multiple="true"
            :compressImage="true"
            :maxSize="2"
            @callback="uploadResponse"
        ></performance-common-upload>

        <!-- 批量查看附件弹窗 -->
        <batch-view-file
            ref="batchViewFileDialog"
            v-if="batchViewFile"
            :taskNoList="taskNoList"
            :batchViewFile.sync="batchViewFile"
        ></batch-view-file>

        <!-- 新建标签弹窗 -->
        <add-label-dialog
            v-if="isShowAddLabel"
            ref="addLabel"
            :isShowAddLabel.sync="isShowAddLabel"
            :conditionList="conditionList"
            :columnList="columnList"
        ></add-label-dialog>

        <!-- 标签管理弹窗 -->
        <label-manage-dialog
            v-if="isShowLabelManage"
            ref="labelManage"
            :isShowLabelManage.sync="isShowLabelManage"
            @handleInitData="handleInitData"
        ></label-manage-dialog>
    </paper>
</template>
<script>
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/lots/VirtualPanel/index.vue';
import AddLabelDialog from './labelManage/AddLabelDialog';
// 标签管理
import LabelManageDialog from './labelManage/labelManageDialog';
import SignInDialog from './component/signInDialog/Index.vue';
import SignChangeRefuse from './component/signInDialog/signChangeRefuse.vue';
import preReceiptDialog from './component/signInDialog/preReceipt.vue';
import preReceiptLog from './component/PreReceiptLog.vue';
import OverdueRegisterDialog from './component/OverdueRegisterDialog.vue';
import SealDialog from './component/sealDialog.vue';
import ReviewDialog from './component/ReviewDialog.vue';
import BatchReceiptUploadDialog from './component/BatchReceiptUploadDialog.vue';
import OverdueDetailSearchDialog from './component/overdueDetail/OverdueDetailSearchDialog.vue';
import PerformancePreviewFile from './component/PerformancePreviewFile.vue';
import BatchViewFile from './component/batchViewFile/index.vue';
import PerformanceCommonUpload from './component/PerformanceCommonUpload.vue';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapState, mapGetters } from 'vuex';
import EvidenceUploadDialog from './component/EvidenceUploadDialog.vue';
import {
    formatSearchData,
    validateSearchData,
    mapOrderTypeDictField,
    dialogConfig,
    dealWithBtnShow,
    validateExceptionApprove,
    evidenceOperateType,
    dealWithTableRowEvidenceBtn,
    dealWithExportParams,
    ReConfirmTip,
    formatSetSearchTime,
    setAllPropertyValuesToNull,
    removeFalsyValues
} from './util.js';
import { batchReceiptEntity, attachmentEntity, validateBatchOverdueRegister } from './entity.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { OPERATE_TYPE } from './component/utils/constant.js';
import { getReceiptSignList, queryCount, exceptionFlow, deletePictureBatch, queryTimeInterval } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { seedIflowURLMap, currentEnv } from './iflowConf';
import config from './config.js';
import getList from '@/components/awesome/page/mPanel3/api';
import dayjs from 'dayjs';
import { reveal, batchReveal } from '@/modules/transport/otp/utils/reveal';
import { sendRevealLogApi } from '@/modules/transport/otp/api/performanceReveal';
import { uniq } from 'lodash';

export default {
    name: 'receiptCenter',
    components: {
        paper,
        mPane,
        SealDialog,
        SignInDialog,
        BatchViewFile,
        OverdueRegisterDialog,
        BatchReceiptUploadDialog,
        OverdueDetailSearchDialog,
        EvidenceUploadDialog,
        SignChangeRefuse,
        preReceiptDialog,
        preReceiptLog,
        reportExport,
        AddLabelDialog,
        LabelManageDialog,
        ReviewDialog,
        PerformancePreviewFile,
        PerformanceCommonUpload
    },
    data () {
        return {
            config: JSON.parse(JSON.stringify(config)),
            timeRangeShortcuts: {
                shortcuts: [
                    { text: '今天', translate: '', today: true },
                    { type: 'd', num: 6, text: '最近一周', translate: '' },
                    { type: 'M', num: 1, text: '最近一个月', translate: '' },
                    { type: 'M', num: 2, text: '最近两个月', translate: '' }
                ]
            },
            pageTotal: 0,
            loading: false, // 列表加载动画
            reviewShow: false, // 反查弹窗
            sealShow: false, // 回单印鉴弹窗
            btnLoading: false, // 批量操作按钮加载动画
            signInShow: false, // 签收弹窗
            batchViewFile: false, // 批量查看附件弹窗
            signChangeRefuseShow: false, // 签改拒弹窗
            preReceiptDialogShow: false, // 预签收弹窗
            logDialogVisible: false, // 预签收日志弹窗
            batchReceiptUploadVisible: false, // 批量上传回单
            overdueRegisterVisible: false, // 逾期登记
            overdueDetailSearchVisible: false, // 逾期明细查询
            leftUploadRightContentVisible: false, // 佐证附件上传弹窗
            isShowAddLabel: false, // 是否显示新建标签弹窗
            isShowLabelManage: false, // 是否显示标签管理弹窗
            totalData: [], // 表格数据
            selected: [], // 选中的表格数据
            taskNoList: [], // 选中的TK单
            tableAttachmentList: [], // 列表附件查看列表
            query: { pageNo: 1, pageSize: 100, param: {} }, // 查询条件
            dictData: {}, // 字典数据
            columnList: '', // 当前列配置
            conditionList: '', // 当前查询条件
            rowData: {}, // 当前操作行数据
            dialogConfig: {}, // 弹窗配置信息
            configurationUrl: config.configurationUrl ? config.configurationUrl : '/api-auth',
            resourceCode: '',
            signChangeRefuseConfig: {}, // 签改拒弹窗配置信息
            attachmentList: [], // 上楼佐证附件列表
            isFirstSearch: true, // 是否第一次查询
            maxSearchDay: 31,
            showEye: false
        };
    },
    computed: {
        ...mapGetters(['user', 'menus']),
        ...mapState({
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier,
            user: state => state.user
        })
    },
    beforeRouteEnter (to, from, next) {
        if (['/performance/waybill-detail'].includes(from.path)) {
            next(vm => {
                if (vm.$route.query.customerOrderNo) {
                    vm.initialSearch();
                };
            });
        } else if (from.path === '/index') {
            next(vm => {
                vm.$nextTick(() => {
                    if (vm.$route.query && Object.keys(vm.$route.query).length) {
                        vm.initialSearchFromIndex();
                    }
                })
            });
        } else {
            next();
        }
    },
    methods: {
        async initialSearch () {
            setAllPropertyValuesToNull(this.$refs.tablePage.$refs.searchList.searchData);
            this.loading = true;
            this.query = {
                ...this.query,
                param: {
                    carrierCodeList: [this.supplier.supplierCode], // 供应商编码-LSP
                    customerOrderNoList: [this.$route.query.customerOrderNo]
                }
            };
            await this.getDictData();
            await Promise.all([ this.getList(), this.getListPageCount() ])
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        async initialSearchFromIndex () {
            setAllPropertyValuesToNull(this.$refs.tablePage.$refs.searchList.searchData);
            const beginDate = dayjs().subtract(30, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss');
            const endDate = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss');
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.searchTime = [beginDate, endDate];
            this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.receiptStatus = this.$route.query.receiptStatus || '';
            this.loading = true;
            this.query = {
                pageNo: 1,
                pageSize: this.query.pageSize,
                param: {
                    carrierCodeList: [ this.supplier.supplierCode ], // 供应商编码-LSP
                    receiptStatus: this.$route.query.receiptStatus || '',
                    beginDate,
                    endDate
                }
            };
            await this.getDictData();
            await Promise.all([ this.getList(), this.getListPageCount() ])
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        foldActionBar () {
            this.$nextTick(() => {
                this.loading = true;
                this.config.table.leftOperation = !this.config.table.leftOperation;
                setTimeout(() => {
                    this.loading = false;
                }, 300);
            });
        },
        /**
         * @description 新建标签
         */
        handleAddLabel () {
            // 获取当前查询条件和列配置
            const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet;
            const conditionList = {
                ...searchData[0].searchData,
                ...formatSetSearchTime(searchData[0].setSearchData)
            };
            // 外层高级弹窗未选时，查询组件只暴露name，需手动处理、保存code
            conditionList.customerCode = conditionList.customerName ? conditionList.customerCode : '';
            conditionList.siteCode = conditionList.siteName ? conditionList.siteCode : '';
            this.conditionList = JSON.stringify(conditionList);
            this.columnList = JSON.stringify(this.$refs.tablePage.tableList);
            this.isShowAddLabel = true;
        },
        /**
         * @description 标签管理
         */
        handleLabelManage () {
            this.isShowLabelManage = true;
        },
        /**
         * @description 标签管理-应用回调函数
         * @params {Object} data 应用行数据
         */
        async handleInitData (data) {
            if (data.columnList) {
                const columnList = JSON.parse(data.columnList);
                // 表格应用
                this.$refs.tablePage.tableList = columnList;
                // 列配置应用
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                const configProps = columnList.split(',').map(item => {
                    if (this.config.table.columns.find(column => column.label === item)) {
                        return this.config.table.columns.find(column => column.label === item).prop;
                    }
                }).join(',');
                const params = {
                    'configName': configProps,
                    'configNameCn': columnList,
                    'subjectType': 'columnsConfig',
                    'moduleCode': this.resourceCode,
                    'id': this.user.employeeId
                };
                const key = `${params.id}-${params.subjectType}-${params.moduleCode}`;
                localStorage.setItem(key, JSON.stringify(params.configNameCn));
                getList.post(this.configurationUrl, params).then(() => {});
            }
            if (data.conditionList) {
                const setSearchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData;
                const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].searchData || {};
                const searchList = JSON.parse(data.conditionList);
                // 组装外层查询参数key值
                const outerSearchData = {
                    customerName: '',
                    customerCode: '', // 查询组件并未向外暴露code，需手动组装参数key值
                    siteName: '',
                    siteCode: '',
                    ...setSearchData
                };
                // 赋值前清空所有查询条件
                Object.keys(searchData).forEach(item => {
                    searchData[item] = null;
                });
                // 外层查询条件赋值（必须过滤，否则查询会携带高级查询参数）
                Object.keys(searchList).filter(v => outerSearchData.hasOwnProperty(v)).forEach(item => {
                    setSearchData[item] = searchList[item];
                });
                // 高级查询赋值
                Object.keys(searchList).forEach(item => {
                    searchData[item] = searchList[item];
                });
                // 解决 赋值后 高级查询组件点击清空icon 不生效的问题
                this.$refs.tablePage.$refs.searchList.keyMap = {
                    customerName: ['customerCode', 'customerName'],
                    siteName: ['siteCode', 'siteName']
                };
            }
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const children = node.subResources;
                if (children) {
                    for (let i = 0; i < children.length; i++) {
                        if (children[i].frontUrl === this.$route.path) {
                            this.resourceCode = children[i].resourceCode;
                        } else {
                            this.deepMenu(children[i]);
                        }
                    }
                }
            }
        },
        /**
         * @description 获取数据字典
         * OTP_ATTACHMENT_TYPE: 附件类型
         * ORDER_TYPE: 订单类型
         * USER_SIGNIN_DETAILS: 新T用户签收详情页显隐控制
         * NETWORK_SIGNIN_DETAILS: 新T网点签收详情页显隐控制
         */
        getDictData () {
            return dictWithUrl('OTP_ATTACHMENT_TYPE,ORDER_TYPE,USER_SIGNIN_DETAILS,NETWORK_SIGNIN_DETAILS,TMS_AI_RESULT,RECEIPT_TYPE').then(res => {
                if (res && +res.code === 0) {
                    this.dictData = res.data || {};
                }
            });
        },
        // 获取阿波罗配置的最大查询时间区间
        getMaxSearchLimit () {
            queryTimeInterval().then(res => {
                if (res && +res.code === 0) {
                    this.maxSearchDay = Number(res.data) || 31;
                }
            }).catch(() => { });
        },
        /**
         * @description 获取列表分页数据
         */
        getListPageCount () {
            const queryParams = {
                ...this.query.param,
                carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
            }
            queryCount(queryParams).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },

        /**
         * @description 获取列表数据
         */
        getList () {
            this.loading = true;
            this.query.param.carrierCodeList = [this.supplier.supplierCode]; // 供应商编码-LSP
            this.query.param = removeFalsyValues(this.query.param);
            getReceiptSignList(this.query).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = this.formatReceiptCenterList(res.data.list || []);
                    this.showEye = this.totalData.some(item => item.desensitizationFlag);
                }
            }).finally(() => {
                this.loading = false;
                this.isFirstSearch = false;
                setTimeout(() => {
                    this.signInShow && (this.$refs.signInDialog.$refs.receiptUpload.delLoading = false);
                    this.signChangeRefuseShow && (this.$refs.SignChangeRefuse.$refs.receiptUpload.delLoading = false);
                }, 1000);
            });
        },

        /**
         * @description 格式化列表数据
         * @param {Array} list 列表数据
         */
        formatReceiptCenterList (list) {
            list.forEach(v => {
                v.evidenceFile = (v.sourceSystem === 'CVTE' && v.distributionLastFlag === 'Y')
                    ? (v.evidenceStatus ? evidenceOperateType[v.evidenceStatus].label : '上传') : ''; // 来源系统为CVTE和最后一段分拨才显示佐证附件上传按钮
                v.orderTypeName = mapOrderTypeDictField(this.dictData.ORDER_TYPE, v); // 处理订单类型字典值映射
                v.showPhotos = v.receiptStatus === '1';
                v.defineStr1Name = v.kaType === 'OFC_JINGDONG' ? v.defineStr1 : ''; // 京东VC单号 kaType === 'OFC_JINGDONG'时 展示
                v.signDistanceName = v.signDistance ? v.signDistance + ' km' : '';
                v.seal = +v.registrationStatus === 1 ? '印鉴' : '';
                v.vipFlag = String(v.vipFlag);
                v.hiddenEvent = dealWithBtnShow(v); // 处理按钮显示条件
            });
            return list;
        },

        /**
         * @description 签收改拒收
         */
        signChangeRefuse (row) {
            this.rowData = row;
            this.signChangeRefuseConfig = dialogConfig('签收改拒收', OPERATE_TYPE['RECEIPT_DETAIL'], '85vw');
            this.signChangeRefuseShow = true;
        },

        openPreReceiptDialog (row) {
            this.rowData = row;
            this.preReceiptDialogShow = true;
        },

        openPreReceiptLog (row) {
            this.rowData = row;
            this.logDialogVisible = true;
        },

        /**
         * @description 打开签收页面
         * @param {Number} isChargeEdit 卸货上楼标识是否可编辑，默认为0则不可编辑，1为可编辑
         */
        openSignInDialog (row, title, operateType, isChargeEdit) {
            this.rowData = row;
            this.dialogConfig = dialogConfig(title, OPERATE_TYPE[operateType], '85vw', isChargeEdit);
            this.signInShow = true;
        },

        recheckBtn (data) {
            this.rowData = data;
            this.reviewShow = true;
        },

        /**
         * @description 逾期登记
         * @param {Object} row 当前操作行数据
         */
        handleOverdueRegister (row) {
            this.selected = row;
            this.overdueRegisterVisible = true;
        },

        /**
         * @description 逾期明细查询
         * @param {Object} row 当前操作行数据
         */
        handleOverdueDetailQueryBtn (row) {
            this.rowData = row;
            this.overdueDetailSearchVisible = true;
        },

        // 批量签收
        handleBatchReceipt () {
            batchReceiptEntity.action(this);
        },

        // 批量上传回单
        handleBatchUploadReceipt () {
            this.batchReceiptUploadVisible = true;
        },

        /**
         * @description 异常审批
         */
        handleExceptionApprove () {
            const isFail = validateExceptionApprove(this.selected);
            if (!isFail) {
                this.btnLoading = true;
                exceptionFlow({
                    createUserCode: this.$store.state.user.userCode, // 用户编码
                    taskNos: this.selected.map(v => (v.taskNo)) // 选中的运输单号集合
                }).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('异常审批成功！');
                        this.getList();
                    }
                }).finally(() => { this.btnLoading = false; });
            }
        },
        // 批量逾期
        handleBatchOverdueRegister () {
            const isQueryOk = validateBatchOverdueRegister(this.selected);
            if (!isQueryOk) return;
            this.overdueRegisterVisible = true;
        },
        // 批量查看附件
        handleBatchViewFile () {
            if (this.selected.length === 0) {
                return this.$message.warning('至少选中一条数据');
            };
            this.taskNoList = this.selected.map(item => item.taskNo);
            this.batchViewFile = true;
        },
        // 批量删除附件
        handleBatchDeleteFile () {
            if (!this.selected.length) {
                return this.$message.warning('至少选中一条数据');
            }
            const finishedList = this.selected.map(item => item.signStatus).filter(v => ['70', '100', '200'].includes(v));
            if (finishedList.length) {
                return this.$message.warning('存在签收单状态为完成、网批签收中、已拒收，不允许删除');
            }
            this.taskNoList = this.selected.map(v => v.taskNo);
            ReConfirmTip(`是否批量删除附件?`, deletePictureBatch, { taskNoList: this.taskNoList }, '删除成功', this);
        },
        // 选中表格行
        selectChange (data) {
            data.forEach(v => (v.currentUserName = this.$store.state.user.userName));
            this.selected = data;
        },

        // 查询
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            this.query = this.getSearchData(_searchData);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData, this.maxSearchDay);
            if (!isQueryOk) return;
            this.getList();
            this.getListPageCount();
        },

        /**
         * @description 组装查询参数
         * @param {Object} data 查询参数
         */
        getSearchData (data) {
            const _searchData = {
                ...this.query,
                pageNo: 1,
                param: {
                    ...data
                }
            };
            delete _searchData.searchTime;
            if (_searchData.param.defineStr1) {
                _searchData.param.kaType = 'OFC_JINGDONG';
            }
            return _searchData;
        },

        /**
         * @description 签收、拒收成功回调
         * @param {String} visible 要隐藏的标识
         */
        handleSuccess (visible) {
            this[visible] = false;
            this.getList();
        },

        /**
         * @description 点击附件图标
         * @param {Object} row 当前操作行数据
         */
        photosBtn (row) {
            attachmentEntity.getAttachmentList(row.id).then(list => {
                this.tableAttachmentList = list;
                this.tableAttachmentList.forEach(v => {
                    v.aiResultName = v.aiResult ? this.dictData.TMS_AI_RESULT[v.aiResult] : '';
                    v.abnormalAiResultName = v.abnormalAiResult ? this.dictData.TMS_AI_RESULT[v.abnormalAiResult] : '';
                    v.customerOrderNo = row.customerOrderNo;
                    v.taskNo = row.taskNo;
                });
            }).catch(({ message }) => {
                this.$message.error(message);
            }).finally(() => {
                this.$refs.performancePreviewFile.show();
            });
        },

        /*
         * @description 导出
        */
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            const doSubmit = () => {
                const exportParams = dealWithExportParams(JSON.parse(JSON.stringify(this.query.param)));
                exportParams.carrierCodeList = [this.supplier.supplierCode]; // 供应商编码-LSP
                exportParams.requestResults = this.$refs.tablePage.tableList;
                submit(exportParams);
            };
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            doSubmit();
        },

        /*
         * @description 明细导出
        */
        exportDetailFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            const doSubmit = () => {
                const exportParams = dealWithExportParams(JSON.parse(JSON.stringify(this.query.param)));
                exportParams.carrierCodeList = [this.supplier.supplierCode]; // 供应商编码-LSP
                submit(exportParams);
            };
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            doSubmit();
        },
        /**
         * @description 点击附件上传按钮
         * @param {Object} row 当前操作行数据
         */
        uploadBtn (row) {
            this.rowData = row;
            this.$refs.performanceCommonUpload.uploadList = [];
            this.$refs.performanceCommonUpload.uploadFileList = [];
            this.$refs.performanceCommonUpload.$refs.icon.click();
        },

        /**
         * @description 列表上传附件成功回调
         */
        uploadResponse (response) {
            attachmentEntity.upload(this, response).then(() => {
                this.$message.success('上传附件成功');
                this.getList();
            }).catch((error) => {
                this.$message.error(error);
            });
        },

        /*
         * @description 行内按钮触发
         * @param {String} val 当前按钮文本
         * @param {Number} index 当前行索引
         * @param {Object} row 当前行数据
         */
        handleBtnClick (val, index, row, prop) {
            if (prop === 'requestUrl') {
                /* TODO: 用于金种子用户的iflow外链域名 */
                const obj = val.split('//');
                const obj1 = obj[1].split('/');
                const env = currentEnv();
                obj1[0] = seedIflowURLMap[env];
                window.open(obj1.join('/'));
            }
            if (prop === 'evidenceFile') {
                this.rowData = row;
                dealWithTableRowEvidenceBtn(this, row);
            }
            if (prop === 'seal' && val === '印鉴') {
                this.rowData = row;
                this.sealShow = true;
            }
        },
        /**
         * 行脱敏数据回显:
         * 1、当行解密
         * 2、相同行解密：收货人姓名+收货人手机+收货详细地址, 以上述三组信息作为判定依据，只要匹配到三组信息一致的，则解密该行数据
         *  */
        onReveal(row) {
            const compareKeys = ['receiverNameEncrypted', 'receiverMobileEncrypted', 'receiverDetailAddrEncrypted'];
            reveal(row, this.config).radiate(this.totalData, compareKeys).done(donedArr => {
                if (donedArr) {
                    this.totalData = [].concat(this.totalData); // 触发表格更新
                    this.sendRevealLog(donedArr);
                }
            });
        },
        // 整页脱敏数据回显
        onRevealAll() {
            batchReveal(this.totalData, this.config).done(donedArr => {
                if (donedArr) {
                    this.totalData = [].concat(this.totalData); // 触发表格更新
                    this.sendRevealLog(donedArr);
                }
            });
        },
        // 发送解密日志
        sendRevealLog(rows) {
            if (rows && rows.length) {
                return sendRevealLogApi({
                    orderNos: uniq(rows.map(item => item.taskNo)),
                    pageCode: 'EL-RECEIPT' // EL-签收中心：EL-RECEIPT
                });
            }
        },

        // 切换当前页数
        pageChange (pageNo) {
            this.query.pageNo = pageNo;
            this.getList();
        },

        // 切换分页显示条数
        sizeChange (pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getList();
        }
    },
    mounted () {
        this.getDictData();
        this.getMaxSearchLimit();
    }
};
</script>
<style lang="less">
@import url('./component/less/receiptCenter.less');
</style>
